export default __webpack_public_path__ + "static/media/Roboto-Regular.25e40da9.ttf";